import { fmtNum, MINUS, NBSP } from '../utils/fmt';
import { useState } from 'react';
import SourceDot from './SourceDot';
import './ETFTab.css';

// ── Static Data ────────────────────────────────────────────────────────────────

const BTC_ETFS = [
  { ticker: 'IBIT', issuer: 'BlackRock',  aum: 50.2, share: 54.6, fee: 0.25, type: 'Spot',    flow:  50.2, note: '🏆 Legnagyobb',    color: '#4a90e2' },
  { ticker: 'FBTC', issuer: 'Fidelity',   aum: 16.1, share: 17.5, fee: 0.25, type: 'Spot',    flow:  16.1, note: '⭐ 2. legnagyobb', color: '#00c853' },
  { ticker: 'GBTC', issuer: 'Grayscale',  aum: 14.0, share: 15.2, fee: 1.50, type: 'Spot',    flow: -22.0, note: '⚠ Magas díj',     color: '#f5a623' },
  { ticker: 'BITB', issuer: 'Bitwise',    aum:  4.2, share:  4.6, fee: 0.20, type: 'Spot',    flow:   4.2, note: '',                 color: '#9b59b6' },
  { ticker: 'ARKB', issuer: 'ARK Invest', aum:  3.5, share:  3.8, fee: 0.21, type: 'Spot',    flow:   3.5, note: '',                 color: '#6c757d' },
  { ticker: 'BITO', issuer: 'ProShares',  aum:  2.1, share:  2.3, fee: 0.95, type: 'Futures', flow:  -0.5, note: '⚠ Futures alapú', color: '#e74c3c' },
  { ticker: 'HODL', issuer: 'VanEck',     aum:  0.8, share:  0.9, fee: 0.20, type: 'Spot',    flow:   0.8, note: '',                 color: '#7f8c8d' },
  { ticker: 'BTCO', issuer: 'Invesco',    aum:  0.5, share:  0.5, fee: 0.25, type: 'Spot',    flow:   0.5, note: '',                 color: '#95a5a6' },
  { ticker: 'EZBC', issuer: 'Franklin',   aum:  0.4, share:  0.4, fee: 0.19, type: 'Spot',    flow:   0.4, note: '💰 Legolcsóbb',   color: '#2ecc71' },
  { ticker: 'BTCW', issuer: 'WisdomTree', aum:  0.2, share:  0.2, fee: 0.30, type: 'Spot',    flow:   0.2, note: '',                 color: '#bdc3c7' },
];

const ETH_ETFS = [
  { ticker: 'ETHA', issuer: 'BlackRock', aum: 3.0, share: 60.0, fee: 0.25, type: 'Spot', note: '🏆 Legnagyobb', color: '#4a90e2' },
  { ticker: 'FETH', issuer: 'Fidelity',  aum: 1.5, share: 30.0, fee: 0.25, type: 'Spot', note: '',              color: '#00c853' },
  { ticker: 'ETHW', issuer: 'Bitwise',   aum: 0.3, share:  6.0, fee: 0.20, type: 'Spot', note: '',              color: '#9b59b6' },
  { ticker: 'CETH', issuer: '21Shares',  aum: 0.1, share:  2.0, fee: 0.21, type: 'Spot', note: '',              color: '#6c757d' },
  { ticker: 'ETHV', issuer: 'VanEck',    aum: 0.1, share:  2.0, fee: 0.20, type: 'Spot', note: '',              color: '#7f8c8d' },
];

const BTC_TOTAL = BTC_ETFS.reduce((s, e) => s + e.aum, 0);
const ETH_TOTAL = ETH_ETFS.reduce((s, e) => s + e.aum, 0);

const AUM_HISTORY = [
  { label: 'Jan 24', val:   2.0 },
  { label: 'Feb 24', val:   8.5 },
  { label: 'Már 24', val:  28.0 },
  { label: 'Ápr 24', val:  52.0 },
  { label: 'Máj 24', val:  57.0 },
  { label: 'Jún 24', val:  55.0 },
  { label: 'Júl 24', val:  60.0 },
  { label: 'Aug 24', val:  58.0 },
  { label: 'Sze 24', val:  62.0 },
  { label: 'Okt 24', val:  72.0 },
  { label: 'Nov 24', val:  95.0 },
  { label: 'Dec 24', val: 105.0 },
  { label: 'Jan 25', val: 108.0 },
  { label: 'Feb 25', val:  95.0 },
  { label: 'Már 25', val:  88.0 },
  { label: 'Ápr 25', val:  85.0 },
  { label: 'Máj 25', val:  92.0 },
];

const RECORDS = [
  { emoji: '🏆', title: 'Legnagyobb napi beáramlás', value: '$1.05B',         sub: 'IBIT — 2024. november 7.' },
  { emoji: '📉', title: 'Legnagyobb napi kiáramlás', value: '-$563M',         sub: 'GBTC — 2024. január 22.' },
  { emoji: '⚡', title: 'Leggyorsabb $10B',           value: '49 nap',         sub: 'IBIT elérte a $10B AUM-ot' },
  { emoji: '🌍', title: 'BTC ETF által tartott BTC',  value: '~1 200 000 BTC', sub: 'A teljes kínálat ~5.7%-a' },
];


const INSTITUTIONS = [
  { name: 'State of Wisconsin Inv. Board', type: 'Állami nyugdíjalap', amount: '~$160M',    etf: 'IBIT, FBTC', date: '2024 Q1', direct: false },
  { name: 'Millennium Management',          type: 'Hedge fund',         amount: '~$2.0B',    etf: 'Több ETF',   date: '2024 Q1', direct: false },
  { name: 'Susquehanna International',      type: 'Kereskedőcég',        amount: '~$1.0B',    etf: 'Több ETF',   date: '2024 Q1', direct: false },
  { name: 'Bracebridge Capital',            type: 'Hedge fund',         amount: '~$450M',    etf: 'IBIT',       date: '2024 Q1', direct: false },
  { name: 'Morgan Stanley',                 type: 'Befektetési bank',   amount: '~$270M',    etf: 'IBIT',       date: '2024 Q2', direct: false },
  { name: 'Goldman Sachs',                  type: 'Befektetési bank',   amount: '~$400M',    etf: 'Több ETF',   date: '2024 Q2', direct: false },
  { name: 'ARK Invest',                     type: 'ETF kibocsátó',      amount: 'Saját ARKB', etf: 'ARKB',      date: '2024',    direct: false },
  { name: 'MicroStrategy',                  type: 'Vállalat',           amount: '~$42B BTC', etf: '— (direkt)', date: '2020-tól', direct: true },
];

const TIMELINE_EVENTS = [
  { date: '2013. július',    dot: '🟠', title: 'GBTC létrehozása',               desc: 'Grayscale elindítja az első Bitcoin befektetési alapot — de még nem valódi ETF', current: false },
  { date: '2021. október',   dot: '🟡', title: 'Első Bitcoin Futures ETF (BITO)', desc: 'ProShares BITO — $1B AUM az első 2 napban, rekord akkor',                        current: false },
  { date: '2023. október',   dot: '🔵', title: 'BlackRock IBIT kérelem',          desc: 'A világ legnagyobb vagyonkezelője benyújtja ETF kérelmét — piaci fordulópont',   current: false },
  { date: '2024. jan. 10.',  dot: '⚡', title: 'SEC jóváhagyás',                  desc: '11 Bitcoin spot ETF egyszerre kap engedélyt — történelmi nap a kripto számára',  current: false },
  { date: '2024. jan. 11.',  dot: '🚀', title: 'Kereskedés indul',                desc: 'IBIT, FBTC, GBTC és társaik elindulnak. Első nap: $4.6B forgalom',               current: false },
  { date: '2024. március',   dot: '💎', title: 'IBIT eléri a $10B AUM-ot',        desc: '49 nap alatt — rekord gyors a pénzügyi termékek történetében',                  current: false },
  { date: '2025. május',     dot: '📍', title: 'Utolsó adatpont ebben az összefoglalóban: $92B', desc: 'A Bitcoin ETF táblázat és az AUM-grafikon ezt az állapotot mutatja. Friss napi adat: Farside.', current: true  },
];

const ACCORDION_ITEMS = [
  {
    id: 'inflow',
    title: '📈 Magas ETF beáramlás → Bullish jel',
    body: 'Amikor az intézményi befektetők nagy mennyiségű Bitcoin ETF-et vásárolnak, az ETF kibocsátóknak valódi BTC-t kell venniük fedezetre. Ez közvetlen vételi nyomást jelent a spot piacon és általában árfelhajtó hatással bír. Az IBIT napi beáramlása a legfontosabb mutató.',
  },
  {
    id: 'outflow',
    title: '📉 ETF kiáramlás → Bearish figyelmeztető jel',
    body: 'Ha az intézményi befektetők eladják ETF részesedésüket, a kibocsátók BTC-t értékesítenek. A GBTC történelmileg nagy kiáramlásokat produkált magas díjai miatt. Jelentős kiáramlás komoly eladói nyomást generálhat.',
  },
  {
    id: 'ibit',
    title: '🏦 Miért fontos a BlackRock IBIT?',
    body: "A BlackRock a világ legnagyobb vagyonkezelője ($10T+ AUM). Az IBIT dominanciája azt jelzi, hogy az intézményi világ elfogadta a Bitcoin-t eszközosztályként. Ha a BlackRock vásárol, mások is követik — ez az 'intézményi legitimáció' szignálja.",
  },
  {
    id: 'howto',
    title: '💡 Hogyan használd ezt a terminálban?',
    body: 'Figyeld az ETF AUM változásait hétről hétre a Farside oldalon. Ha az AUM növekszik miközben a BTC ára stagnál = akkumuláció jele. Ha az AUM csökken erősen = intézményi kilépés jele. Kombináld a Fear & Greed indexszel és a funding rátával a legjobb eredményért.',
  },
];

const LINK_CARDS = [
  { name: 'Farside Investors', url: 'https://farside.co.uk/bitcoin-etf-flow', desc: 'Napi BTC és ETH ETF pénzáramlási adatok — ingyenes' },
];

const ALTCOIN_ETFS = [
  { coin: 'XRP',  ticker: 'XRPZ', issuer: 'Franklin Templeton', aum: '~$1.21B',  start: '2025. nov. 14.', fee: '0.19%', feeVal: 0.19, note: '🏆 Legjobb teljesítmény', color: '#00aae4' },
  { coin: 'SOL',  ticker: 'BSOL', issuer: 'Bitwise',            aum: '~$760M',   start: '2025. okt. 28.', fee: '0.20%', feeVal: 0.20, note: 'Staking hozammal',        color: '#9945ff' },
  { coin: 'SOL',  ticker: 'GSOL', issuer: 'Grayscale',          aum: '~$190M',   start: '2025. okt. 29.', fee: '2.50%', feeVal: 2.50, note: '⚠️ Magas díj',            color: '#9945ff' },
  { coin: 'SOL',  ticker: 'FSOL', issuer: 'Fidelity',           aum: '~$147M',   start: '2025. nov. 18.', fee: '0.25%', feeVal: 0.25, note: '',                        color: '#9945ff' },
  { coin: 'DOGE', ticker: 'GDOG', issuer: 'Grayscale',          aum: '~$15M',    start: '2025. nov.',      fee: '2.50%', feeVal: 2.50, note: '📉 Gyenge indulás',       color: '#c3a634' },
  { coin: 'HYPE', ticker: 'THYP', issuer: '21Shares',           aum: '~$37M',    start: '2026. máj. 12.', fee: '0.30%', feeVal: 0.30, note: '🚀 Első HYPE ETF (Nasdaq)', color: '#00d4ff' },
  { coin: 'HYPE', ticker: 'BHYP', issuer: 'Bitwise',            aum: '~$27M',    start: '2026. máj. 15.', fee: '0.34%', feeVal: 0.34, note: 'Staking + díjból finanszírozott visszavásárlás',     color: '#00d4ff' },
];

const ALTCOIN_CARDS = [
  { label: 'Összes XRP ETF AUM',      value: '$1.21B',         sub: 'Kumulatív beáramlás: $1.21B' },
  { label: 'Összes SOL ETF AUM',      value: '$1.12B+',        sub: '8 aktív alap, BSOL vezet 62%-kal' },
  { label: 'DOGE ETF',                value: 'Gyenge indulás', sub: 'Első nap: $1.4M forgalom (várt: $11M)' },
  { label: 'HYPE ETF-ek (1. hét)',    value: '$54M+',          sub: 'THYP + BHYP kombinált beáramlás' },
];

const ALTCOIN_ACCORDION = [
  {
    id: 'alt1',
    title: '🔑 Mi különbözteti meg az altcoin ETF-eket a Bitcoin ETF-től?',
    body: 'A Bitcoin ETF-ek 2024 januárjában indultak, és 2025 májusában ~$92B AUM-ot kezeltek. Az altcoin ETF-ek 2025 végén kaptak jóváhagyást — sokkal kisebb méretből indulnak, de gyorsabb növekedési pályán lehetnek. A legnagyobb különbség: a SOL ETF staking hozamot is fizet (BSOL), ami a Bitcoin ETF-eknél nem lehetséges.',
  },
  {
    id: 'alt2',
    title: '⚡ Mit jelent a BSOL staking funkciója?',
    body: 'A Bitwise BSOL ETF nemcsak a SOL árát követi, hanem staking jutalmakat is generál (~6-7% éves hozam). Ez azt jelenti hogy az intézményi befektetők egyszerre kapnak árkitettséget ÉS passzív hozamot — ez teljesen új az ETF piacon és komoly versenyelőny más SOL ETF-ekkel szemben.',
  },
  {
    id: 'alt3',
    title: '📊 XRP vs SOL ETF — Melyik teljesít jobban?',
    body: 'Az XRP ETF-ek indulásuk óta egyetlen kiáramlás napot sem láttak (2026. január 7. kivételével). A SOL ETF-ek szintén erősek, de az XRP vezet a kumulatív beáramlásban ($1.21B vs ~$1.12B). Az XRP előnye: egyértelműbb felhasználási eset (határokon átnyúló fizetések), a SOL előnye: staking hozam és erősebb DeFi ökoszisztéma.',
  },
  {
    id: 'alt4',
    title: '🐕 Miért teljesített gyengén a DOGE ETF?',
    body: 'A Grayscale DOGE ETF (GDOG) az első nap csak $1.4M forgalmat generált — a várt $11M töredékét. Az ok: a DOGE egy meme coin, amelynek nincs valódi intézményi narratívája, és a 2.50%-os díj rendkívül magas. A befektetők inkább az alacsonyabb díjú és erősebb fundamentumú BTC, ETH, XRP és SOL ETF-eket választják.',
  },
  {
    id: 'alt5',
    title: '🚀 HYPE ETF — Friss indulás (2026. május)',
    body: 'A Hyperliquid (HYPE) ETF 2026 májusában sikeresen elindult! A 21Shares THYP (Nasdaq) 2026. május 12-én, a Bitwise BHYP (NYSE) május 15-én kezdett kereskedni. Az első héten $54M+ kombinált beáramlás érkezett, és HYPE új ATH-t ért el ($62.24). A Bitwise különlegessége: a BHYP menedzsment díjainak 10%-át HYPE token vásárlásra fordítja — ez beépített vételi mechanizmust jelent. A Grayscale GHYP ETF is jóváhagyás alatt van, ami háromoldalú versenyt hozhat. Hyperliquid $2.9 billió futures forgalmat kezelt 2025-ben és ~60%-os piaci részesedéssel bír az onchain perp szektorban.',
  },
];

const ALT_VS_BTC = [
  { label: 'BTC ETF-ek',  aum: 92.0,   color: '#f7931a' },
  { label: 'ETH ETF-ek',  aum:  5.0,   color: '#627eea' },
  { label: 'XRP ETF-ek',  aum:  1.2,   color: '#00aae4' },
  { label: 'SOL ETF-ek',  aum:  1.1,   color: '#9945ff' },
  { label: 'HYPE ETF-ek', aum:  0.064, color: '#00d4ff' },
  { label: 'DOGE ETF-ek', aum:  0.015, color: '#c3a634' },
];

// ── Helpers ────────────────────────────────────────────────────────────────────

function feeColor(fee) {
  if (fee <= 0.25) return 'var(--positive)';
  if (fee <= 0.50) return '#f5a623';
  return 'var(--negative)';
}

function fmtFlow(v) {
  // v milliárd dollárban
  return `${v >= 0 ? '+' : MINUS}${fmtNum(Math.abs(v), 1)}${NBSP}Mrd${NBSP}$`;
}


// ── Summary Cards ──────────────────────────────────────────────────────────────

function SummaryCard({ label, value, trend, trendCls, sub }) {
  return (
    <div className="etf-sum-card">
      <div className="etf-sum-label">{label}</div>
      <div className="etf-sum-value">{value}</div>
      {trend && <div className={`etf-sum-trend ${trendCls ?? ''}`}>{trend}</div>}
      {sub   && <div className="etf-sum-sub">{sub}</div>}
    </div>
  );
}

// ── AUM History Chart ─────────────────────────────────────────────────────────

function AUMChart({ data }) {
  const W = 700, H = 190;
  const PAD = { top: 30, left: 48, right: 24, bottom: 30 };
  const plotW = W - PAD.left - PAD.right;
  const plotH = H - PAD.top - PAD.bottom;
  const Y_MAX = 120;

  const xOf = i => PAD.left + (i / (data.length - 1)) * plotW;
  const yOf = v => PAD.top  + plotH * (1 - v / Y_MAX);

  const pts = data.map((d, i) => ({ x: xOf(i), y: yOf(d.val) }));

  const linePath = pts
    .map((p, i) => `${i === 0 ? 'M' : 'L'}${fmtNum(p.x, 1)},${fmtNum(p.y, 1)}`)
    .join(' ');
  const areaPath =
    `${linePath} ` +
    `L${pts[pts.length - 1].x.toFixed(1)},${(H - PAD.bottom).toFixed(1)} ` +
    `L${pts[0].x.toFixed(1)},${(H - PAD.bottom).toFixed(1)} Z`;

  const athIdx = data.reduce((mi, d, i, a) => (d.val > a[mi].val ? i : mi), 0);
  const curIdx = data.length - 1;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="etf-aum-chart" preserveAspectRatio="xMidYMid meet">
      <defs>
        <linearGradient id="etfAumGrad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%"   stopColor="#00ff88" stopOpacity="0.28" />
          <stop offset="100%" stopColor="#00ff88" stopOpacity="0.02" />
        </linearGradient>
      </defs>

      {[0, 25, 50, 75, 100].map(v => {
        const y = yOf(v);
        if (y < PAD.top - 4 || y > H - PAD.bottom + 4) return null;
        return (
          <g key={v}>
            <line x1={PAD.left} y1={y} x2={W - PAD.right} y2={y}
              stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
            <text x={PAD.left - 5} y={y + 3.5}
              textAnchor="end" fill="var(--text3)" fontSize="9" fontFamily="monospace">
              {fmtNum(v, 0)} Mrd $
            </text>
          </g>
        );
      })}

      <line x1={PAD.left} y1={H - PAD.bottom} x2={W - PAD.right} y2={H - PAD.bottom}
        stroke="rgba(255,255,255,0.10)" strokeWidth="1" />

      <path d={areaPath} fill="url(#etfAumGrad)" />
      <path d={linePath} fill="none" stroke="#00cc70" strokeWidth="2" strokeLinejoin="round" />

      {data.map((d, i) => {
        if (i % 2 !== 0) return null;
        return (
          <text key={i} x={xOf(i)} y={H - PAD.bottom + 16}
            textAnchor="middle" fill="var(--text3)" fontSize="8.5" fontFamily="monospace">
            {d.label}
          </text>
        );
      })}

      <circle cx={pts[athIdx].x} cy={pts[athIdx].y} r="5"
        fill="#00ff88" stroke="var(--surface)" strokeWidth="2" />
      <text x={pts[athIdx].x} y={pts[athIdx].y - 10}
        textAnchor="middle" fill="#00ff88" fontSize="9" fontFamily="monospace" fontWeight="bold">
        ATH {fmtNum(data[athIdx].val, 1)} Mrd $
      </text>

      {curIdx !== athIdx && (
        <>
          <circle cx={pts[curIdx].x} cy={pts[curIdx].y} r="4"
            fill="#f5a623" stroke="var(--surface)" strokeWidth="2" />
          <text x={pts[curIdx].x - 6} y={pts[curIdx].y - 10}
            textAnchor="end" fill="#f5a623" fontSize="9" fontFamily="monospace" fontWeight="bold">
            {fmtNum(data[curIdx].val, 1)} Mrd $
          </text>
        </>
      )}
    </svg>
  );
}

// ── Records Grid ──────────────────────────────────────────────────────────────

function RecordsGrid({ records }) {
  return (
    <div className="etf-records-grid">
      {records.map((r, i) => (
        <div key={i} className="etf-record-card">
          <div className="etf-record-emoji">{r.emoji}</div>
          <div className="etf-record-title">{r.title}</div>
          <div className="etf-record-value">{r.value}</div>
          <div className="etf-record-sub">{r.sub}</div>
        </div>
      ))}
    </div>
  );
}

// ── GBTC vs IBIT Comparison ───────────────────────────────────────────────────

function ComparisonCard() {
  const gbtcRows = [
    { k: 'Indulás',           v: '2013',          cls: '' },
    { k: 'AUM (2025. máj.)',  v: '$14.0B',         cls: '' },
    { k: 'Évi díj',           v: '1.50% ⚠️',       cls: 'etf-neg' },
    { k: 'Max AUM valaha',    v: '~$43B (2021)',    cls: '' },
    { k: 'IBIT-nek veszített',v: '~$29B',          cls: 'etf-neg' },
  ];
  const ibitRows = [
    { k: 'Indulás',           v: '2024. jan. 11.', cls: '' },
    { k: 'AUM (2025. máj.)',  v: '$50.2B',         cls: '' },
    { k: 'Évi díj',           v: '0.25% ✅',        cls: 'etf-pos' },
    { k: 'Rekord',            v: '$10B 49 nap alatt', cls: '' },
    { k: 'BlackRock kezelt',  v: '$10T+ vagyon',   cls: '' },
  ];

  return (
    <div className="etf-vs-block">
      <div className="etf-vs-wrap">
        {/* GBTC */}
        <div className="etf-vs-side etf-vs-gbtc">
          <div className="etf-vs-ticker" style={{ color: '#f5a623' }}>GBTC</div>
          <div className="etf-vs-name">Grayscale Bitcoin Trust</div>
          <div className="etf-vs-rows">
            {gbtcRows.map(r => (
              <div key={r.k} className="etf-vs-row">
                <span className="etf-vs-key">{r.k}</span>
                <span className={`etf-vs-val ${r.cls}`}>{r.v}</span>
              </div>
            ))}
          </div>
          <div className="etf-vs-badge etf-vs-badge-neg">📉 Tőkét veszít</div>
        </div>

        {/* VS divider */}
        <div className="etf-vs-divider">
          <span className="etf-vs-vs">VS</span>
          <span className="etf-vs-arrow">→</span>
        </div>

        {/* IBIT */}
        <div className="etf-vs-side etf-vs-ibit">
          <div className="etf-vs-ticker" style={{ color: '#4a90e2' }}>IBIT</div>
          <div className="etf-vs-name">iShares Bitcoin Trust</div>
          <div className="etf-vs-rows">
            {ibitRows.map(r => (
              <div key={r.k} className="etf-vs-row">
                <span className="etf-vs-key">{r.k}</span>
                <span className={`etf-vs-val ${r.cls}`}>{r.v}</span>
              </div>
            ))}
          </div>
          <div className="etf-vs-badge etf-vs-badge-pos">📈 Domináns</div>
        </div>
      </div>

      <div className="etf-vs-desc">
        A GBTC 2013 óta működik, de 1.50%-os díja miatt óriási tőkekiáramlást szenvedett el az IBIT megjelenése után.
        A BlackRock belépése legitimálta a Bitcoin ETF piacot és rekord gyorsasággal gyűjtötte a tőkét —
        mindössze 49 nap alatt elérte azt, amire más alapoknak évek kellettek.
      </div>
    </div>
  );
}

// ── Institutional Investors Table ─────────────────────────────────────────────

function InstitutionalTable({ rows }) {
  return (
    <div className="etf-inst-wrap">
      <div className="etf-tbl-wrap">
        <table className="etf-tbl">
          <thead>
            <tr>
              <th>Intézmény</th>
              <th>Típus</th>
              <th className="right">Becsült Részesedés</th>
              <th>ETF</th>
              <th>Bejelentés</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className={r.direct ? 'etf-inst-direct' : ''}>
                <td className="etf-inst-name">{r.name}</td>
                <td className="etf-inst-type">{r.type}</td>
                <td className={`right etf-inst-amount ${r.direct ? '' : 'etf-pos'}`}>
                  {r.amount}
                </td>
                <td className="etf-inst-etf">
                  <span className={`etf-inst-etf-badge ${r.direct ? 'direct' : ''}`}>{r.etf}</span>
                </td>
                <td className="etf-inst-date">{r.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="etf-flow-note" style={{ marginTop: 8 }}>
        ⚠️ Az adatok nyilvános SEC bejelentéseken (13F) alapulnak. A tényleges pozíciók változhatnak.
        MicroStrategy BTC-t közvetlenül tart, nem ETF-en keresztül.
      </div>
    </div>
  );
}

// ── Adoption Timeline ─────────────────────────────────────────────────────────

function ETFTimeline({ events }) {
  return (
    <div className="etf-timeline">
      {events.map((e, i) => (
        <div key={i} className={`etf-tl-item ${e.current ? 'current' : ''}`}>
          <div className="etf-tl-dot-wrap">
            <span className="etf-tl-emoji">{e.dot}</span>
          </div>
          <div className="etf-tl-content">
            <div className="etf-tl-date">{e.date}</div>
            <div className="etf-tl-title">{e.title}</div>
            <div className="etf-tl-desc">{e.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── Flow Calculator ───────────────────────────────────────────────────────────

const BTC_PRICE_FALLBACK = 95000;
const TOTAL_AUM_M = BTC_TOTAL * 1000;   // the BTC ETF table total (2025. május)
const DAILY_VOL_M = 30000;

function impactLabel(pct) {
  if (pct < 0.5)  return { text: 'Minimális hatás',   cls: 'etf-pos' };
  if (pct < 2)    return { text: 'Mérsékelt hatás',   cls: 'trend-neutral' };
  if (pct < 5)    return { text: 'Érzékelhető hatás', cls: 'trend-neutral' };
  return            { text: 'Jelentős piaci hatás',   cls: 'etf-neg' };
}

function FlowCalculator({ btcPrice }) {
  const BTC_PRICE = btcPrice || BTC_PRICE_FALLBACK;
  const [raw, setRaw] = useState('500');
  const amountM  = Math.max(0, parseFloat(raw) || 0);
  const amountUSD = amountM * 1_000_000;
  const btcNeeded = amountUSD / BTC_PRICE;
  const aumPct    = (amountM / TOTAL_AUM_M) * 100;
  const volPct    = (amountM / DAILY_VOL_M) * 100;
  const impact    = impactLabel(volPct);

  function fmt(n) {
    return n.toLocaleString('hu-HU', { maximumFractionDigits: 0 });
  }

  return (
    <div className="etf-calc">
      <div className="etf-calc-subtitle">
        Számítsd ki, mennyi BTC-t kell a piacon venni egy adott ETF beáramláshoz
      </div>

      <div className="etf-calc-input-row">
        <label className="etf-calc-label">ETF beáramlás összege</label>
        <div className="etf-calc-input-wrap">
          <span className="etf-calc-prefix">$</span>
          <input
            className="etf-calc-input"
            type="number"
            min="0"
            max="50000"
            step="50"
            value={raw}
            onChange={e => setRaw(e.target.value)}
          />
          <span className="etf-calc-suffix">millió USD</span>
        </div>
        <div className="etf-calc-presets">
          {[100, 500, 1000, 5000].map(v => (
            <button key={v} className="etf-calc-preset" onClick={() => setRaw(String(v))}>
              ${v}M
            </button>
          ))}
        </div>
      </div>

      <div className="etf-calc-results">
        <div className="etf-calc-result">
          <div className="etf-calc-rlabel">Szükséges BTC vásárlás</div>
          <div className="etf-calc-rvalue">{fmt(btcNeeded)} BTC</div>
          <div className="etf-calc-rsub">@ {fmtNum(Math.round(BTC_PRICE), 0)} $ / BTC</div>
        </div>
        <div className="etf-calc-result">
          <div className="etf-calc-rlabel">Összes ETF AUM %-a</div>
          <div className="etf-calc-rvalue">{fmtNum(aumPct, 3)}%</div>
          <div className="etf-calc-rsub">a ~{fmtNum(BTC_TOTAL, 0)} Mrd $ BTC ETF AUM-ból (2025. máj.)</div>
        </div>
        <div className="etf-calc-result">
          <div className="etf-calc-rlabel">Napi BTC spot forgalom %-a</div>
          <div className="etf-calc-rvalue">{fmtNum(volPct, 2)}%</div>
          <div className="etf-calc-rsub">~$30B becsült napi forgalom</div>
        </div>
        <div className="etf-calc-result etf-calc-impact">
          <div className="etf-calc-rlabel">Becsült piaci hatás</div>
          <div className={`etf-calc-rvalue ${impact.cls}`}>{impact.text}</div>
          <div className="etf-calc-rsub">
            {volPct < 0.5  ? 'Piac könnyen felszívja' :
             volPct < 2    ? 'Kis árnyomást okozhat'  :
             volPct < 5    ? 'Érezhető árfelhajtó erő' :
                             'Komoly spot árhatás'}
          </div>
        </div>
      </div>

      <div className="etf-calc-note">
        * BTC ár: {btcPrice ? 'élő CoinGecko ár' : '~$95,000 (becsült)'} · Napi forgalom: ~$30B (becsült spot átlag) · Csak tájékoztató jellegű
      </div>
    </div>
  );
}

// ── Altcoin ETF Table ────────────────────────────────────────────────────────

function AltcoinTable({ rows }) {
  return (
    <div className="etf-tbl-wrap">
      <table className="etf-tbl">
        <thead>
          <tr>
            <th>Coin</th>
            <th>Legjobb ETF</th>
            <th>Kibocsátó</th>
            <th className="right">AUM</th>
            <th>Indulás</th>
            <th className="right">Évi Díj</th>
            <th>Megjegyzés</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td>
                <span className="etf-dot" style={{ background: r.color }} />
                <span className="etf-tkr">{r.coin}</span>
              </td>
              <td><span className="etf-tkr" style={{ fontSize: 12 }}>{r.ticker}</span></td>
              <td className="etf-issuer">{r.issuer}</td>
              <td className="right etf-aum-val">{r.aum}</td>
              <td className="etf-inst-date">{r.start}</td>
              <td className="right" style={{ color: r.feeVal != null ? feeColor(r.feeVal) : 'var(--text3)', fontWeight: 700 }}>
                {r.fee}
              </td>
              <td className="etf-note">{r.note}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ── Alt vs BTC Comparison Chart ───────────────────────────────────────────────

function AltVsBtcChart({ data }) {
  const W = 600, ROW_H = 40;
  const PAD = { top: 8, left: 100, right: 90, bottom: 8 };
  const H = PAD.top + data.length * ROW_H + PAD.bottom;
  const maxAum = data[0].aum;
  const barMaxW = W - PAD.left - PAD.right;
  const labelCol = PAD.left + barMaxW + 10;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="etf-alt-cmp-svg" preserveAspectRatio="xMidYMid meet">
      {data.map((d, i) => {
        const y = PAD.top + i * ROW_H;
        const barW = Math.max((d.aum / maxAum) * barMaxW, 2);
        const barH = 26;
        const barY = y + (ROW_H - barH) / 2;
        const aumLabel = d.aum >= 1
          ? `${fmtNum(d.aum, 1)} Mrd $`
          : `${fmtNum(d.aum * 1000, 0)} M $`;
        return (
          <g key={d.label}>
            <text x={PAD.left - 8} y={barY + barH / 2 + 4}
              textAnchor="end" fill="var(--text2)" fontSize="11" fontFamily="monospace" fontWeight="700">
              {d.label}
            </text>
            <rect x={PAD.left} y={barY} width={barMaxW} height={barH}
              fill="rgba(255,255,255,0.04)" rx="3" />
            <rect x={PAD.left} y={barY} width={barW} height={barH}
              fill={d.color} opacity="0.82" rx="3" />
            <text x={labelCol} y={barY + barH / 2 + 4}
              fill={d.color} fontSize="11" fontFamily="monospace" fontWeight="700">
              {aumLabel}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

// ── ETF Table ─────────────────────────────────────────────────────────────────

function ETFTable({ title, etfs, total, showFlow }) {
  const maxAum = etfs[0].aum;
  return (
    <div className="etf-tbl-block">
      <div className="etf-tbl-title">{title}</div>
      <div className="etf-tbl-wrap">
        <table className="etf-tbl">
          <thead>
            <tr>
              <th>Ticker</th>
              <th>Kibocsátó</th>
              <th className="right">AUM</th>
              <th className="right">Piaci Részesedés</th>
              <th className="right">Évi Díj</th>
              <th>Típus</th>
              {showFlow && <th className="right">Indulás óta flow</th>}
              <th>Megjegyzés</th>
            </tr>
          </thead>
          <tbody>
            {etfs.map(e => (
              <tr key={e.ticker}>
                <td>
                  <span className="etf-dot" style={{ background: e.color }} />
                  <span className="etf-tkr">{e.ticker}</span>
                </td>
                <td className="etf-issuer">{e.issuer}</td>
                <td className="right">
                  <div className="etf-aum-cell">
                    <span className="etf-aum-val num">{fmtNum(e.aum, 1)} Mrd $</span>
                    <div className="etf-aum-bar-wrap">
                      <div
                        className="etf-aum-bar"
                        style={{ width: `${(e.aum / maxAum * 100).toFixed(1)}%`, background: e.color }}
                      />
                    </div>
                  </div>
                </td>
                <td className="right etf-share">{fmtNum(e.share, 1)}%</td>
                <td className="right" style={{ color: feeColor(e.fee), fontWeight: 700 }}>
                  {fmtNum(e.fee, 2)}%
                </td>
                <td>
                  <span className={`etf-type-badge ${e.type === 'Futures' ? 'futures' : 'spot'}`}>
                    {e.type}
                  </span>
                </td>
                {showFlow && e.flow != null && (
                  <td
                    className="right"
                    style={{ color: e.flow >= 0 ? 'var(--positive)' : 'var(--negative)', fontWeight: 700 }}
                  >
                    {fmtFlow(e.flow)}
                    {e.ticker === 'GBTC' && (
                      <span className="etf-gbtc-warn" title="Magas díjai miatt jelentős tőkekiáramlás"> ⚠</span>
                    )}
                  </td>
                )}
                <td className="etf-note">{e.note}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="etf-total-row">
              <td colSpan={2}><strong>Összesen</strong></td>
              <td className="right"><strong>{fmtNum(total, 1)} Mrd $</strong></td>
              <td className="right"><strong>100%</strong></td>
              <td colSpan={showFlow ? 4 : 3} />
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

// ── Accordion ─────────────────────────────────────────────────────────────────

function Accordion({ items }) {
  const [openId, setOpenId] = useState(null);
  return (
    <div className="etf-accordion">
      {items.map(item => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id} className={`etf-acc-item ${isOpen ? 'open' : ''}`}>
            <button className="etf-acc-head" onClick={() => setOpenId(isOpen ? null : item.id)}>
              <span className="etf-acc-title">{item.title}</span>
              <span className="etf-acc-arrow">{isOpen ? '▲' : '▼'}</span>
            </button>
            <div className="etf-acc-body-wrap" style={{ maxHeight: isOpen ? '240px' : '0' }}>
              <div className="etf-acc-body">{item.body}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ── Link Cards ────────────────────────────────────────────────────────────────

function LinkCards({ links }) {
  return (
    <div className="etf-links">
      {links.map(l => (
        <a key={l.name} href={l.url} target="_blank" rel="noopener noreferrer" className="etf-link-card">
          <div className="etf-link-name">{l.name} ↗</div>
          <div className="etf-link-desc">{l.desc}</div>
        </a>
      ))}
    </div>
  );
}

// ── Main Component ─────────────────────────────────────────────────────────────

export default function ETFTab({ btcPrice }) {
  return (
    <div className="etf-root">

      {/* HEADER */}
      <div className="etf-header">
        <div className="etf-header-left">
          <div className="etf-title">📊 Kripto ETF Műszerfal<SourceDot source="kézzel összeállított összefoglaló (élő napi adat: Farside Investors)" note="Utoljára frissítve: 2026. május." /></div>
          <div className="etf-subtitle">Statikus összefoglaló</div>
        </div>
        <div className="etf-notice-chip">
          Nem élő adat &nbsp;|&nbsp;
          <a href="https://farside.co.uk" target="_blank" rel="noopener noreferrer">
            Élő pénzáramlási adatokért: farside.co.uk →
          </a>
        </div>
      </div>

      {/* SUMMARY CARDS */}
      <div className="etf-sum-cards">
        <SummaryCard label="Összes BTC ETF AUM"      value={`${fmtNum(BTC_TOTAL, 1)} Mrd $`} sub="2025. májusi állapot" />
        <SummaryCard label="Összes ETH ETF AUM"      value={`${fmtNum(ETH_TOTAL, 1)} Mrd $`} sub="statikus adat" />
        <SummaryCard label="Domináns ETF"            value="IBIT"    sub="BlackRock · 54% részesedés (2025. máj.)" />
        <SummaryCard label="Legolcsóbb Spot ETF"     value="EZBC"    sub="Franklin · 0.19% évi díj" />
      </div>

      {/* AUM HISTORY CHART */}
      <section className="etf-section">
        <div className="etf-section-title">📈 Kumulatív ETF Beáramlás 2024 óta</div>
        <div className="etf-chart-label">Összes Kripto ETF AUM alakulása (Mrd USD)</div>
        <AUMChart data={AUM_HISTORY} />
        <div className="etf-chart-note">
          Becsült havi adat &nbsp;·&nbsp;
          Csúcs a sorozatban: <strong>$108B</strong> (2025. január) &nbsp;·&nbsp;
          Utolsó adatpont: <strong>$92B</strong> (2025. május)
        </div>
      </section>

      {/* BTC ETF TABLE */}
      <section className="etf-section">
        <ETFTable title="₿ Bitcoin ETF-ek (2025. májusi állapot)" etfs={BTC_ETFS} total={BTC_TOTAL} />
      </section>

      {/* RECORDS */}
      <section className="etf-section">
        <div className="etf-section-title">🏅 Rekordok &amp; Mérföldkövek</div>
        <RecordsGrid records={RECORDS} />
      </section>

      {/* FARSIDE LIVE FLOW LINK */}
      <section className="etf-section">
        <div className="etf-section-title">📡 Valós napi ETF pénzáramlási adatok</div>
        <div className="etf-farside-card">
          <div className="etf-farside-body">
            <div className="etf-farside-desc">
              A pontos napi beáramlás/kiáramlás adatokért látogasd meg a Farside Investors oldalát —
              ők gyűjtik össze az összes BTC és ETH ETF napi flow adatát ingyen.
            </div>
            <a
              href="https://farside.co.uk/bitcoin-etf-flow"
              target="_blank"
              rel="noopener noreferrer"
              className="etf-farside-btn"
            >
              Megnyitás: farside.co.uk →
            </a>
          </div>
        </div>
      </section>

      {/* GBTC vs IBIT */}
      <section className="etf-section">
        <div className="etf-section-title">⚔️ GBTC vs IBIT — A Nagy Verseny</div>
        <ComparisonCard />
      </section>

      {/* INSTITUTIONAL INVESTORS */}
      <section className="etf-section">
        <div className="etf-section-title">🏛️ Intézményi Befektetők — Kik tartanak BTC ETF-et?</div>
        <div className="etf-flow-sub">
          Ismert intézményi befektetők akik nyilvánosan bejelentették BTC ETF pozícióikat
        </div>
        <InstitutionalTable rows={INSTITUTIONS} />
      </section>

      {/* ADOPTION TIMELINE */}
      <section className="etf-section">
        <div className="etf-section-title">📅 Az ETF-ek idővonala — A Bitcoin ETF története</div>
        <ETFTimeline events={TIMELINE_EVENTS} />
      </section>

      {/* FLOW CALCULATOR */}
      <section className="etf-section">
        <div className="etf-section-title">🧮 ETF pénzáramlás-kalkulátor</div>
        <FlowCalculator btcPrice={btcPrice} />
      </section>

      {/* ETH ETF TABLE */}
      <section className="etf-section">
        <ETFTable title="Ξ Ethereum ETF-ek" etfs={ETH_ETFS} total={ETH_TOTAL} />
      </section>

      {/* ALTCOIN ETFs */}
      <section className="etf-section">
        <div className="etf-section-title">🪙 ALTCOIN ETF-EK — Az Új Hullám</div>
        <div className="etf-alt-intro">
          2025 végén és 2026 elején az SEC jóváhagyta az első altcoin spot ETF-eket. Az XRP, Solana, Dogecoin és Hyperliquid
          ETF-ek megnyitották az utat az intézményi tőke számára a Bitcoin és Ethereum mellett.
        </div>
        <div className="etf-tbl-title">Altcoin ETF-ek — 2026. májusi adatok</div>
        <AltcoinTable rows={ALTCOIN_ETFS} />
        <div className="etf-alt-cards">
          {ALTCOIN_CARDS.map((c, i) => (
            <div key={i} className="etf-sum-card">
              <div className="etf-sum-label">{c.label}</div>
              <div className="etf-sum-value etf-alt-card-val">{c.value}</div>
              <div className="etf-sum-sub">{c.sub}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ALTCOIN ACCORDION */}
      <section className="etf-section">
        <div className="etf-section-title">📚 Altcoin ETF-ek — Amit Tudnod Kell</div>
        <Accordion items={ALTCOIN_ACCORDION} />
      </section>

      {/* ALT vs BTC COMPARISON */}
      <section className="etf-section">
        <div className="etf-section-title">📈 Altcoin vs Bitcoin ETF — AUM Összehasonlítás</div>
        <div className="etf-tbl-title">Altcoin ETF-ek vs Bitcoin ETF-ek — Méretkülönbség (BTC, ETH: 2025. május · altcoinok: 2026. május)</div>
        <AltVsBtcChart data={ALT_VS_BTC} />
        <div className="etf-alt-context">
          Az altcoin ETF-ek még gyerekcipőben járnak a Bitcoin ETF-ekhez képest. Az XRP, SOL és HYPE ETF-ek összesen
          ~$2.4B AUM-ot kezelnek — ez a Bitcoin ETF-ek 2.6%-a. Azonban az indulási tempójuk alapján 2026 végére
          reálisan elérhető az $5–10B szint, ha a piaci feltételek kedvezőek maradnak.
        </div>
      </section>

      {/* ACCORDION */}
      <section className="etf-section">
        <div className="etf-section-title">💡 Mit jelent az ETF?</div>
        <Accordion items={ACCORDION_ITEMS} />
      </section>

      {/* LINKS */}
      <section className="etf-section">
        <div className="etf-section-title">📡 Élő ETF pénzáramlási adatok</div>
        <LinkCards links={LINK_CARDS} />
      </section>

    </div>
  );
}
